import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button, Modal } from 'antd'

import { DEFAULT_PLUGIN_PREVIEW } from '../../config/media'
import { PluginDetailsWrapper } from './style'
import PluginActions from '../../actions/PluginAction'
import PluginContents from './PluginContents'

const PluginDetails = (props) => {

  const [isVisible, setIsVisible] = useState(false);

  const { pluginData } = props;

  const onHandleOnClose = () => {
    setIsVisible(false);
  }

  const onHandleModalBuy = () => {
    const { UpdatePluginDetail } = props;
    UpdatePluginDetail(true);
    setIsVisible(false);
    props.history.push('/billing');
  }

  const renderModal = () => {
    return (
      <PluginContents
        isVisible={true}
      />)
  }

  return (
    <PluginDetailsWrapper>
      <div className='Plugin-detail-wrapper'>
        <div className='d-flex'>
          <Link to="/plugin" className='myplugin-explore'>Explore</Link>
          <Link to="/plugin" className='myplugin-link'>{`> Plugin details`}</Link>
        </div>
        <div className='plugin-detail-card-warpper'>
          <div className='d-flex detail-content-wrapper'>
            <PluginContents
              isVisible={false}
              setIsVisible={setIsVisible}
            />
            <div className='d-flex card-wrapper'>
              <div className='slider-arrow-right'></div>
              <div>
                <img className='plugin-card-img' alt='plugin-home' src={pluginData && pluginData.logo
                  ? pluginData.logo
                  : DEFAULT_PLUGIN_PREVIEW}></img>
                {pluginData && pluginData.name === 'automatic-kyc' && <h1 className='plugin-card-content'>★ Featured plugin</h1>}
              </div>
              <div className='slider-arrow-left'></div>
            </div>
          </div>
          <Modal
            visible={isVisible}
            width={450}
            onCancel={onHandleOnClose}
            className="plugin-detail-card-warpper"
            footer={
              <div className='footer-wrapper'>
                <div className='custom-divider'></div>
                <p className='footer-content'>Do you want proceed with purchase?</p>
                <Button onClick={onHandleModalBuy} className='footer-btn'>Buy</Button>
              </div>
            }
          >
            {renderModal()}
          </Modal>
        </div>
        <div className="plugin-divider"></div>
        <div className='about-wrapper'>
          <div className="about-label">About</div>
          <div className="about-contents">
            <h1 className='about-title'>OverView</h1>
            <p>{`All users to upload documents and input identity info`}</p>
            <div>
              <h1 className='about-footer'>Main features</h1>
              <h1>--</h1>
            </div>
          </div>
        </div>
      </div>
    </PluginDetailsWrapper >
  )
}


const mapStateToProps = (store) => {
  return {
    pluginData: store.plugin.pluginData,
  }
}

const mapDispatchToProps = (dispatch) => ({
  UpdatePluginDetail: bindActionCreators(PluginActions.isBilling, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(PluginDetails);
